// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";
// import { GoogleOAuthProvider } from '@react-oauth/google';
// import 'react-toastify/dist/ReactToastify.css';
// import { NotificationProvider } from './Contexts/NotificationContext';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId="315301409213-ulq0t3ob3it5fqdt8udgc5qfcc6qunl9.apps.googleusercontent.com">
//       <BrowserRouter>
//         <NotificationProvider>
//           <App />
//         </NotificationProvider>
//       </BrowserRouter>
//     </GoogleOAuthProvider>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "react-toastify/dist/ReactToastify.css";
import { NotificationProvider } from "./Contexts/NotificationContext";
import { SnackbarProvider } from "notistack";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="315301409213-ulq0t3ob3it5fqdt8udgc5qfcc6qunl9.apps.googleusercontent.com">
      <BrowserRouter>
        <NotificationProvider>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            autoHideDuration={5000}
            action={(snackbarId) => (
              <IconButton
                size="small"
                color="inherit"
                onClick={() => closeSnackbar(snackbarId)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          >
            <App />
          </SnackbarProvider>
        </NotificationProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
